import PropTypes from 'prop-types';
import React from 'react';
import { ModalBody, ModalFooter, Button } from 'reactstrap';
// eslint-disable-next-line import/no-unresolved, import/extensions
import Icon from '../../../common/containers/icon';
import CheckSettingsRow from './checkSettingsRow';
const ChecksListView = _ref => {
  let checksArray = _ref.checksArray,
    onToggle = _ref.onToggle,
    onDelete = _ref.onDelete,
    onGenerateClick = _ref.onGenerateClick,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalBody, {
    style: {
      maxHeight: '60vh',
      overflowY: 'auto'
    }
  }, checksArray.length > 0 ? /*#__PURE__*/React.createElement("div", null, checksArray.map(check => /*#__PURE__*/React.createElement(CheckSettingsRow, {
    key: check.id,
    checkId: check.id,
    check: check,
    onToggle: onToggle,
    onDelete: onDelete
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "text-center py-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-0"
  }, "No checks configured yet."))), /*#__PURE__*/React.createElement(ModalFooter, {
    className: "d-flex justify-content-end gap-2"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "success",
    onClick: e => {
      e.stopPropagation();
      onGenerateClick();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "wand-magic-sparkles",
    style: {
      marginRight: 8
    }
  }), "Generate Suggestions"), /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: onClose
  }, "Close")));
};
ChecksListView.propTypes = {
  checksArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  onToggle: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onGenerateClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default ChecksListView;